import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import BuildFilter from '../../sitewide/Filter/BuildFilter'
import BlastMessageFiltersModal from './BlastMessageFiltersModal'
import SearchBar from '../../sitewide/Filter/SearchBar'
import AllLocationsCheckbox from '../../sitewide/Filter/AllLocationsCheckbox'
import css from './search-filters.css'

class Filters extends Component {
  state = {
    filterModalShowing: false,
  }

  toggleFilterModal = () => {
    const { filterModalShowing } = this.state
    this.setState({ filterModalShowing: !filterModalShowing })
  }

  renderLastButton = () => {
    const {
      isOrthoTrac,
      patientsWithApptsInTimeRange,
      hasRemindersTier2,
      hasTopsAlertsPlus,
    } = this.props
    if (isOrthoTrac && !patientsWithApptsInTimeRange) return null
    return (
      (hasRemindersTier2 || hasTopsAlertsPlus) && (
        <button className={css.filterButton} onClick={this.toggleFilterModal}>
          <span className={css.label}>
            {!patientsWithApptsInTimeRange
              ? 'Patient Statuses'
              : 'More Options'}
          </span>
        </button>
      )
    )
  }

  render() {
    const {
      allLocationsChecked,
      doctors,
      hasDSO,
      handleSearchChange,
      fetchNewPatientList,
      patientsWithApptsInTimeRange,
      searchValue,
      locations,
      patientStatuses,
      selectAppointmentDoctor,
      selectAppointmentLocation,
      selectATypesAndPStatuses,
      selectedAppointmentTypeIds,
      selectedPatientStatusIds,
      selectedDoctorId,
      selectedLocationId,
      toggleAllLocations,
      userLocations,
    } = this.props

    const { filterModalShowing } = this.state
    const multipleLocations = userLocations && userLocations.length > 1

    return (
      <div className={css.filters}>
        <div className={css.filterButtons}>
          {patientsWithApptsInTimeRange && (
            <div>
              <BuildFilter
                arrToFilter={doctors}
                defaultOption="All Doctors"
                filterLabel="preferred_name"
                onChange={selectAppointmentDoctor}
                value={selectedDoctorId}
              />
              {!hasDSO && (
                <BuildFilter
                  arrToFilter={locations}
                  defaultOption="All Locations"
                  filterLabel="name"
                  onChange={selectAppointmentLocation}
                  value={selectedLocationId}
                />
              )}
            </div>
          )}
          {this.renderLastButton()}
        </div>
        <BlastMessageFiltersModal
          hasTimeRange={patientsWithApptsInTimeRange}
          open={filterModalShowing}
          patientStatuses={patientStatuses}
          selectATypesAndPStatuses={selectATypesAndPStatuses}
          selectedAppointmentTypeIds={selectedAppointmentTypeIds}
          selectedPatientStatusIds={selectedPatientStatusIds}
          toggleFilterModal={this.toggleFilterModal}
        />
        <div className={css.searchBar}>
          {!process.env.REACT_APP_IS_TOPS && (
            <SearchBar
              handleSearchParams={fetchNewPatientList}
              value={searchValue}
              onChange={handleSearchChange}
              placeholder="Search by name, phone, or email"
            />
          )}
        </div>
        <div className={css.allLocationsCheckbox}>
          {hasDSO && multipleLocations && (
            <AllLocationsCheckbox
              handleCheck={toggleAllLocations}
              checked={allLocationsChecked}
            />
          )}
        </div>
      </div>
    )
  }
}

Filters.propTypes = {
  allLocationsChecked: PropTypes.bool.isRequired,
  doctors: PropTypes.arrayOf(PropTypes.object),
  fetchNewPatientList: PropTypes.func.isRequired,
  hasDSO: PropTypes.bool.isRequired,
  hasRemindersTier2: PropTypes.bool.isRequired,
  hasTopsAlertsPlus: PropTypes.bool.isRequired,
  handleSearchChange: PropTypes.func.isRequired,
  isOrthoTrac: PropTypes.bool.isRequired,
  locations: PropTypes.arrayOf(PropTypes.object),
  patientStatuses: PropTypes.arrayOf(PropTypes.object).isRequired,
  patientsWithApptsInTimeRange: PropTypes.bool.isRequired,
  searchValue: PropTypes.string.isRequired,
  selectAppointmentDoctor: PropTypes.func.isRequired,
  selectAppointmentLocation: PropTypes.func.isRequired,
  selectATypesAndPStatuses: PropTypes.func.isRequired,
  selectedAppointmentTypeIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedPatientStatusIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  selectedDoctorId: PropTypes.string.isRequired,
  selectedLocationId: PropTypes.string.isRequired,
  toggleAllLocations: PropTypes.func.isRequired,
}

const mapStateToProps = ({
  account: {
    auth: {
      hasDSO,
      hasRemindersTier2,
      hasTopsAlertsPlus,
      pmsType,
    },
    user: { locations },
  },
}) => ({
  isOrthoTrac: pmsType.startsWith('OrthoTrac'),
  hasDSO,
  hasRemindersTier2,
  hasTopsAlertsPlus,
  userLocations: locations,
})

export default connect(mapStateToProps)(Filters)



// WEBPACK FOOTER //
// ./src/components/PatientGroups/PatientList/Filters.js